var TextTypes = {
	Varieties: {
		FICTION: "fiction",
		NON_FICTION: "non-fiction",
		FICTION_AND_NON_FICTION: "fiction-and-non-fiction",

		// For use in other contexts
		SPECIFIC_TEXT: "specific-text",

		TYPES: {
			"fiction-and-non-fiction": { 
				name: "Fiction and non-fiction", 
				altName: "All Texts",
				abbreviation: "F/NF"
			},
			"fiction": { 
				name: "Fiction", 
				altName: "Fiction Texts",
				abbreviation: "F"
			},
			"non-fiction": { 
				name: "Non-fiction", 
				altName: "Non-Fiction Texts",
				abbreviation: "NF"
			},
		},

		BOTH: "fiction-and-non-fiction",

		getName: function(textVarietyKey) {
			var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
			if (textVariety) {
				return textVariety.name;
			}
		},

		getAltName: function(textVarietyKey) {
			var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
			if (textVariety) {
				return textVariety.altName;
			} else if (textVarietyKey == TextTypes.Varieties.SPECIFIC_TEXT) {
				return "Specific Text";
			}
		},

		getAbbreviation: function(textVarietyKey) {
			var textVariety = TextTypes.Varieties.TYPES[textVarietyKey];
			if (textVariety) {
				return textVariety.abbreviation;
			}
		}
	},

	CompletionTypes: {
		TEXT_COMPLETED: 	"text-completed",
		NO_TEXT: 			"no-text",
		TEXT_IN_PROGRESS:	"text-in-progress",
		SPECIFIC_CHAPTER: 	"specific-chapter",
		DEFAULT: 			"default",

		// No nice way to load in the types (I think)
		TYPES: {
			"text-completed":     { pluralName: "completed texts" },
			"no-text":            { pluralName: "text provided" },
			"text-in-progress":   { pluralName: "in progress texts" },
			"specific-chapter":   { pluralName: "specific chapter texts" },
			"default":            { pluralName: "texts" }
		},

		requiresText: function(completionType) {
			return completionType != TextTypes.CompletionTypes.NO_TEXT;
		},

		getPluralName: function(completionType) {
			var textVariety = TextTypes.CompletionTypes.TYPES[completionType] ||
				TextTypes.CompletionTypes.TYPES[TextTypes.CompletionTypes.DEFAULT];

			return textVariety.pluralName;
		}
	}
}

module.exports = TextTypes;



// WEBPACK FOOTER //
// ./modules/lib/academic/TextTypes.js